export const PORTAL_CARRY_PATH = '/portal/carry';

export const PORTAL_CARRY_STRUCTURE_PATH = `${PORTAL_CARRY_PATH}?tab=structure`;

const STRUCTURE_PATH = `${PORTAL_CARRY_PATH}/structure`;

export const PORTAL_CARRY_STAK_PATH = `${STRUCTURE_PATH}/stak`;

export const PORTAL_CARRY_COOPERATIVE_PATH = `${STRUCTURE_PATH}/cooperative`;

export const PORTAL_CARRY_HOLDING_PATH = `${STRUCTURE_PATH}/holding`;

export function portalCarryFundPath(fundId: string): string {
  return `${PORTAL_CARRY_PATH}/funds/${fundId}`;
}

export function portalCarryStructureFundPath(fundId: string): string {
  return `${STRUCTURE_PATH}/funds/${fundId}`;
}

export function portalCarryDocumentsPath(fundId: string): string {
  return `${PORTAL_CARRY_PATH}/documents/${fundId}`;
}
